const testimonials = [
  {
    name: "Robert H.",
    location: "Ponte Vedra Beach, FL",
    rating: 5,
    text: "Our golf group of twelve had a St. Andrews package booked for June — flights, caddies, distillery tours, the works. Three weeks before departure, one of our guys discovered his passport had expired eight months earlier. Fast Passport Center got his renewal processed in five business days. He made the trip, played the Old Course, and we didn't have to cancel a $20,000 group package. Incredible service for golf travelers.",
    service: "Passport Renewal",
  },
  {
    name: "Dr. Patricia W.",
    location: "Ponte Vedra Beach, FL",
    rating: 5,
    text: "I am a physician affiliated with Mayo Clinic Jacksonville and was invited to present at the European Society of Cardiology conference in London with three weeks' notice. My passport was valid but had only four months remaining — insufficient for UK entry. Fast Passport Center handled my expedited renewal in four business days. I presented my research, made the conference, and didn't miss a single day. Professional, fast, and completely reliable.",
    service: "Expedited Renewal",
  },
  {
    name: "Jennifer and Mark T.",
    location: "Ponte Vedra Beach, FL",
    rating: 5,
    text: "We booked a family Caribbean cruise from JAXPORT for spring break — our two children, my mother, and us. I checked passports two weeks before sailing and found both kids' passports had expired. I was panicked. Fast Passport Center walked me through the child passport process step by step, I shipped everything overnight from the UPS Store at Sawgrass Village, and all four passports arrived in time. We made the cruise with two days to spare. Cannot recommend them enough.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PonteVedraBeachTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Ponte Vedra Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Ponte Vedra Beach golfers, medical professionals, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}